// Free-text creative brief for a project, collected by the Moodboard modal in
// the Ask tab and fed to the Creative Ask agent as project context.
//
// Every answer is a plain string on purpose. Extraction stays a copy rather
// than an enum mapping, so a richer, more visual input experience can replace
// the modal later without touching storage or the document builder.

export const MAX_MOODBOARD_FIELD_LENGTH = 2000

export const MOODBOARD_FIELDS = [
  {
    key: 'summary',
    label: 'What is this project about?',
    hint: '',
    multiline: true,
  },
  {
    key: 'colorPalette',
    label: 'Color palette',
    hint: '',
    multiline: false,
  },
  {
    key: 'shootingStyle',
    label: 'Shooting style',
    hint: 'Camera, lenses, drones, cranes, etc.',
    multiline: false,
  },
  {
    key: 'locationGeography',
    label: 'Shooting locations',
    hint: 'City, state, or country',
    multiline: false,
  },
  {
    key: 'interiorExterior',
    label: 'Interior or exterior',
    hint: 'INT, EXT, or both',
    multiline: false,
  },
  {
    key: 'weather',
    label: 'Weather conditions',
    hint: '',
    multiline: false,
  },
  {
    key: 'timePeriod',
    label: 'Time period',
    hint: '1920s, 30s, 40s, etc.',
    multiline: false,
  },
  {
    key: 'clothingStyle',
    label: 'Clothing style',
    hint: '',
    multiline: false,
  },
  {
    key: 'socialClass',
    label: 'Class',
    hint: 'Luxury, urban, trashy, elegant, etc.',
    multiline: false,
  },
]

export const MOODBOARD_FIELD_KEYS = MOODBOARD_FIELDS.map((field) => field.key)

export const defaultMoodboard = () =>
  Object.fromEntries(MOODBOARD_FIELD_KEYS.map((key) => [key, '']))

// Caps each answer so a pasted screenplay cannot blow the agent's context
// budget, and drops unknown keys so a stale saved blob cannot grow the
// document with fields the builder does not render.
export function normalizeMoodboard(value) {
  const source = value && typeof value === 'object' && !Array.isArray(value) ? value : {}
  return Object.fromEntries(
    MOODBOARD_FIELD_KEYS.map((key) => [
      key,
      `${source[key] || ''}`.trim().slice(0, MAX_MOODBOARD_FIELD_LENGTH),
    ]),
  )
}

export function moodboardHasAnswers(value) {
  const normalized = normalizeMoodboard(value)
  return MOODBOARD_FIELD_KEYS.some((key) => !!normalized[key])
}
